<template>
    <base-modal
        :reference="'addBusCompanyPrice'"
        :title="'Añadir precio de bus'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'md'"
    >
        <template v-slot:body v-if="show">
            <div>
                <p>
                    Añadir un nuevo precio de compañía de bus
                </p>
            </div>
            <form>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Compañía de bus <span class="text-danger">[campo obligatorio]</span></label>
                        <v-select
                            :options="busCompanies"
                            label="name"
                            :reduce="(company) => company.id"
                            v-model="form.bus_company_id"
                            class="border"
                            style=""
                        >
                        </v-select>
                    </div>
                </div>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Asientos desde <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.number_seats_bottom_range"
                            placeholder="Inserte número"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Asientos hasta <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.number_seats_top_range"
                            placeholder="Inserte número"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Tarifa <span class="text-danger">[campo obligatorio]</span></label>
                        <v-select
                            :options="busFareTypes"
                            label="name"
                            :reduce="(fare) => fare.id"
                            v-model="form.bus_fare_id"
                            class="border"
                            style=""
                        >
                        </v-select>
                    </div>
                </div>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Precio <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.price"
                            placeholder="Inserte precio"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div v-if="errors">
                    <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                        El campo compañía es obligatorio y los asientos y el precio tiene que ser mayores de 0
                    </p>
                </div>
            </form>
        </template>

    </base-modal>

</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable */
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";


export default {
    components: {
        BaseModal,
    },
    data() {
        return {
            show: false,
            form: {
                bus_company_id: null,
                bus_fare_id: null,
                number_seats_bottom_range: 0,
                number_seats_top_range: 0,
                price: 0
            }
        }
    },
    async mounted() {
        this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
            const current = "addBusCompanyPrice";
            if (modalId == current) {
                this.show = true
            }
        })
    },
    methods: {
        async acceptAction() {
            if ( this.errors ) {
                return 
            }
            if ( this.form.price.includes(',') ) {
                console.log('test and replace point')
                this.form.price = this.form.price.replace(',', '.')
            }
            
            let data = {
                payload: {...this.form}
            }
            await this.$store.dispatch("buscompaniesprices/createBusCompanyPrice", data )
            .then( () => {
                this.$bvModal.hide("addBusCompanyPrice");
                // reset form data
                this.form = {
                    bus_company_id: null,
                    bus_fare_id: null,
                    number_seats_bottom_range: 0,
                    number_seats_top_range: 0,
                    price: 0
                }
                this.$notify({
                    group: "foo",
                    title: "Precio añadido",
                    text: "Se ha creado una nuevo precio para la compañía de buses",
                    type: "success",
                });
            })
            .catch()
            
        }
    },
    computed: {
        ...mapGetters(["busCompanies", "busFareTypes"]),
        errors() {
            if ( this.form.bus_company_id == null || this.form.number_seats_bottom_range == 0 
                || this.form.number_seats_top_range == 0 || this.form.price < 0 ) {
                return true
            }
            return false
        }
    }
}
</script>